import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers";
import { saveState, persistedState } from "./persisted.store";
import {
  createStateSyncMiddleware,
  // initMessageListener,
} from "redux-state-sync";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middlewareEnhancer = applyMiddleware(thunk, createStateSyncMiddleware());
const composedEnhancers = composeEnhancer(middlewareEnhancer);

const store = createStore(reducers, persistedState, composedEnhancers);

// Checking Saving User data if not available in storage
store.subscribe(() => {
  saveState(store.getState());
});

export default store;
